// @flow
import React from 'react';
import { Redirect } from 'react-router';
import Login from '../account/components/Login';
import CreateAccount from '../account/components/CreateAccount';
import ConvertCoachTrialAccount from '../account/components/ConvertCoachTrialAccount';
import ForgotPassword from '../account/components/ForgotPassword';
import AssistantCoachSettings from '../coachManagement/components/AssistantCoachSettings';
import SubscriptionPlans from '../planManagement/components/SubscriptionPlans';
import AcceptAssistantCoachInvite from '../coachManagement/components/AcceptAssistantCoachInvite';
import CancelPlan from '../planManagement/components/CancelPlan';
import PaymentInfo from '../payment/components/PaymentInfo';
import BillingHistory from '../billing/components/BillingHistory';
import Receipt from '../billing/components/Receipt';
import IntegrationApiTokens from '../integrations/components/IntegrationApiTokens';
import GrantParentalConsent from '../parentalConsent/components/GrantParentalConsent';
import ResetPassword from '../resetPassword/components/ResetPassword';
import DataExport from '../dataExport/components/DataExport';
import MarketplaceSubscriptions from '../marketplaceSubscriptions/components/MarketplaceSubscriptions';
import Account from '../account/components/Account';

export default {
    HOME: {
        component: () => <Redirect to="/payment" />,
        path: '/'
    },
    LOGIN: {
        component: Login,
        path: '/login',
        isPublic: true
    },
    CREATE_ACCOUNT_CONVERT: {
        component: ConvertCoachTrialAccount,
        path: '/create-account/convert',
        isPublic: true
    },
    CREATE_ACCOUNT: {
        component: CreateAccount,
        path: '/create-account',
        isPublic: true,
        exact: true
    },
    FORGOT_PASSWORD: {
        component: ForgotPassword,
        path: '/forgot-password',
        isPublic: true
    },
    UNAUTHENTICATED_RESET_PASSWORD: {
        component: ResetPassword,
        path: '/reset-password/:secret?',
        isPublic: true
    },
    ASSISTANT_COACHES: {
        component: AssistantCoachSettings,
        path: '/assistant-coaches'
    },
    SUBSCRIPTION_PLANS: {
        BASE: {
            component: SubscriptionPlans,
            path: '/subscription-plans'
        },
        CANCEL: {
            component: CancelPlan,
            path: '/subscription-plans/cancel'
        }
    },
    ACCEPT_ASSISTANT_COACH: {
        component: AcceptAssistantCoachInvite,
        path: '/accept-assistant-coach-invite',
        isPublic: true
    },
    GRANT_PARENTAL_CONSENT: {
        component: GrantParentalConsent,
        path: '/grant-parental-consent',
        isPublic: true
    },
    PAYMENT: {
        component: PaymentInfo,
        path: '/payment'
    },
    BILLING: {
        BASE: {
            component: BillingHistory,
            path: '/billing'
        },
        DETAIL: {
            component: Receipt,
            path: '/billing/invoice/:id'
        }
    },
    INTEGRATIONS: {
        component: IntegrationApiTokens,
        path: '/integrations'
    },
    DATA_EXPORT: {
        component: DataExport,
        path: '/data-export'
    },
    MARKETPLACE_SUBSCRIPTIONS: {
        component: MarketplaceSubscriptions,
        path: '/marketplace-subscriptions'
    },
    ACCOUNT: {
        component: Account,
        path: '/account'
    },
};
